import SelectBox, { Item, OtherSelectBoxProps } from '@/components/select/SelectBox';
import { MultiSelectProps, SingleSelectProps } from '@/components/select/useSelectBox';
import { CustomerOrderStatuses, SupplierOrderStatuses } from '@/modules/order/models/OrderStatus';

type OrderStatusSelectBoxProps<T extends Item> =
  | (SingleSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple?: false;
        isSupplier?: boolean;
      })
  | (MultiSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple: true;
        isSupplier?: boolean;
      });

export interface OrderStatusItem {
  id: string;
  name: string;
}

const OrderStatusSelectBox = (props: OrderStatusSelectBoxProps<OrderStatusItem>) => {
  const { label = 'Status:', placeholder = 'Select status', isSupplier = false } = props;

  const listOrderStatuses = (): Promise<OrderStatusItem[]> => {
    return new Promise((resolve) => {
      const statuses = Object.entries(isSupplier ? SupplierOrderStatuses : CustomerOrderStatuses)
        .filter(([, item]) => item.visible)
        .map(([status, item]) => ({ status, title: item.title }));

      const items = statuses.map(({ status, title }) => {
        return {
          id: status,
          name: title,
        };
      });

      resolve(items);
    });
  };

  return (
    <SelectBox<OrderStatusItem>
      {...props}
      name="orderStatus"
      label={label}
      placeholder={placeholder}
      queryFn={listOrderStatuses}
    />
  );
};

export default OrderStatusSelectBox;
